module.exports = __webpack_public_path__ + "assets/img/gal_07.058a964a.jpg";